import React, { Component } from 'react';
import { crudActions } from "@sm/services/crudActions";
import Form from "@sm/core/Form";

class OtcCashoutComponent extends Component {
  collectedStatusValue = "COLLECTED";
  state = {
    otcCashoutGeneralFields: [[
      {
        name: "confirmationLink",
        label: "Confirmation Link",
        fieldType: "input",
        flexGrow: 10,
      },
      {
        name: "status",
        label: "Status",
        fieldType: "select",
        flexGrow: 5,
        disabled: true,
        getOptions: () => this.getOptionsFromState("statuses"),
        items: "statuses",
      },
      {
        name: "notes",
        label: "Notes",
        fieldType: "textarea",
        flexGrow: 10,
      }, { fieldType: "empty" }, { fieldType: "empty" }
    ],
    [
      { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      { fieldType: "button" },
    ]],
  };

  componentDidMount() {
    const { statuses } = this.props;
    if (statuses) {
      this.setState({
        statuses: statuses,
      });
    }
  }

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (oldProps.statuses.length !== newProps.statuses.length) {
      this.setState({
        statuses: newProps.statuses,
      });
    }
  }

  onSaveDataEntries = () => {
    const { savedData, form } = this.props;

    form.map(elem => elem.incomingFunds = elem.incomingFunds ? parseFloat(elem.incomingFunds).toFixed(2) : elem.incomingFunds);
    form.map(elem => elem.requestedBalance = elem.requestedBalance ? parseFloat(elem.requestedBalance).toFixed(2) : elem.requestedBalance);
    form.map(elem => elem.fxRate = elem.fxRate ? parseFloat(elem.fxRate).toFixed(2) : elem.fxRate);
    const formToSettle = form.filter(elem => elem.availableBalance > 0 || "status" in elem);
    const fieldsToCheck = ["requestedBalance", "incomingFunds", "fxRate"];

    formToSettle.forEach(row => {
      const shouldRequire = (row.requestedBalance || row.incomingFunds || row.fxRate) && row.account !== "All";

      row.fieldRules.forEach(fieldRule => {
        if (fieldsToCheck.includes(fieldRule.name)) {
          (fieldRule.rules ??= {}).required = shouldRequire;
        }
      });
    });
    const formToSettleRequested = form.filter(elem => elem.requestedBalance > 0 || "status" in elem);
    const isValid = formToSettle.map((elem) => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isValid, isValid);
    if (isValid && (formToSettleRequested.length <= 1)) {
      this.errorUpdate('Nothing to Collect');
      return;
    }

    if (isValid) {
      const formState = form[form.length - 1];
      const incomingFunds = formToSettleRequested.filter(item => item.hasOwnProperty("account") && item.account !== "All").map((otc) => ({
        accountId: otc.accountId,
        disputedFunds: otc.disputedFunds,
        availableBalance: otc.availableBalance,
        requestedBalance: otc.requestedBalance,
        incomingFundsAmount: otc.incomingFunds,
        fxRate: otc.fxRate,
      }));
      const data = {
        notes: formState.notes,
        status: formState.status,
        confirmationLink: formState.confirmationLink,
        totalBalance: formToSettle[formToSettle.length - 2].availableBalance,
        currency: formToSettle[formToSettle.length - 2].currency,
        date: savedData.date,
        companyId: savedData.company,
        fxPair: formState.fxPair,
        incomingFunds: incomingFunds
      };

      crudActions.post(`v1/incoming/funds`, data,)
        .then(() => {
          this.afterSuccessSave("Operation successful.");
        }).catch((err) => {
          this.errorUpdate(err ? err.message : '');
        });
    }
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    
    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);
    
    if (isFormValid) {
      crudActions.get(`v1/psp/accounts/balances?pspAccountIds=${controls.accountIds}&companyId=${controls.company}`).then((response) => {
        // const filteredResponse = response.filter(elem => elem.balance > 0 || elem.disputedFunds > 0);
        if (!response.length) {
          this.errorUpdate(" Well done! All balances are 0.00, there are no funds to collect.", "info");
          this.reset();
        } else {
          const newState =  this.populateOtcCashoutForm(response, controls.fxPair.split("/"));
          Object.assign(newState, {
            showSecondPanel: true,
            loadingDataInput: false,
            lockButton: false,
          });
          this.updateState(newState);
        }
      }).catch((error) => {
        this.reset();
        this.errorUpdate(error ? error.message : "");
      });
    }
  };

  reset = () => {
    const newState = {
      showSecondPanel: false,
      otcCashoutForm: [],
    };
    this.updateField("OTC_CASHOUT", []);
    this.updateState(newState);
  };

  populateOtcCashoutForm = (accounts, fxPairArray) => {
    const { controls, companiesAccounts, companiesPsps } = this.props;
    const { otcCashoutGeneralFields, statuses } = this.state;
    const stateForUpdate = { };
    const otcCashoutForm = [];
    let OTC_CASHOUT = [];
    const isFxRateFixed = fxPairArray[0] === fxPairArray[1];
    accounts.forEach(account => {
      otcCashoutForm.push(this.getAccountRowOtcCashoutForm(account, controls, companiesAccounts, companiesPsps, isFxRateFixed));
    });

    otcCashoutForm.sort((a, b) => {
      const lastLetterCompare = a.provider[0].localeCompare(b.provider[0]);
      if (lastLetterCompare !== 0) return lastLetterCompare;
      return a.account[0].localeCompare(b.account[0]);
    });

    otcCashoutForm.forEach((account) => OTC_CASHOUT.push(this.getOtcCashoutAccountRowFields(false, isFxRateFixed, Number(account.availableBalance) <= 0)));

    if (otcCashoutForm.length > 1) {
      otcCashoutForm.push(this.getOtcCashoutFormTotal(controls, accounts, isFxRateFixed));
    }

    if (otcCashoutForm.length > 1) {
      OTC_CASHOUT.push( this.getOtcCashoutAccountRowFields(true, true, true));
    }
    OTC_CASHOUT.push([]);
    OTC_CASHOUT = OTC_CASHOUT.concat(otcCashoutGeneralFields);
    this.updateField("OTC_CASHOUT", OTC_CASHOUT);

    const status = statuses.find(elem => elem.value === this.collectedStatusValue)?.value;
    const otcCashoutFormState = new Form(
      {
        confirmationLink: "",
        status: status || "",
        notes: "",
        fxPair: controls.fxPair
      },
      [
        {
          name: "confirmationLink",
          type: "isUrl",
        },
        {
          name: "status",
          type: "isString",
          rules: {
            required: true,
          }
        },
        {
          name: "notes",
          type: "isString"
        }
      ]
    );

    Object.assign(stateForUpdate,  {
      settlementMids: [...otcCashoutForm]
    });
    otcCashoutForm.push(new Form(), otcCashoutFormState);
    Object.assign(stateForUpdate,  {
      otcCashoutForm: otcCashoutForm,
      otcCashoutFormState: otcCashoutFormState,
    });
    return stateForUpdate;
  };

  getOtcCashoutAccountRowFields = (commonLastRow, isFxRateFixed, requestedBalanceDisabled) => {
    return  [{
      name: "provider",
      label: commonLastRow ? "" : "Provider",
      fieldType: "input",
      disabled: true,
      flexGrow: 10
    },{
      name: "account",
      label: commonLastRow ? "" : "Account",
      fieldType: "input",
      disabled: true,
      flexGrow: 10
    }, {
      name: "disputedFunds",
      label: "Disputed Funds",
      fieldType: "input",
      formatValue: true,
      disabled: true,
      flexGrow: 7
    },
    {
      name: "payments",
      label: "Payments",
      fieldType: "input",
      formatValue: true,
      disabled: true,
      flexGrow: 7
    },
    {
      name: "collected",
      label: "Collected",
      fieldType: "input",
      formatValue: true,
      disabled: true,
      flexGrow: 7
    },
    {
      name: "topUps",
      label: "Top Ups",
      fieldType: "input",
      formatValue: true,
      disabled: true,
      flexGrow: 7
    },
    {
      name: "availableBalance",
      label: commonLastRow ? "Total Due Balance" : "Due Balance",
      fieldType: "input",
      formatValue: true,
      disabled: true,
      flexGrow: 8
    },
    {
      name: "requestedBalance",
      label: "Collected Balance",
      fieldType: "input",
      disabled: requestedBalanceDisabled,
      placeholder: this.props?.controls?.fxPair?.split("/")[1],
      flexGrow: 8
    }, {
      name: "fxRate",
      label: "FX Rate",
      disabled: isFxRateFixed || requestedBalanceDisabled,
      fieldType: "input"
    }, {
      name: "incomingFunds",
      label: "Inbound Settlement",
      fieldType: "input",
      placeholder: this.props?.controls?.fxPair?.split("/")[0],
      flexGrow: 8,
      disabled: isFxRateFixed || requestedBalanceDisabled,
    }, {
      name: "checkBox",
      fieldType: "checkBox",
      autoMethod: (index) => this.props.onAutoFunction(index),
      alignSelf: "end",
      disabled: true,
      empty: commonLastRow,
      flexGrow: 0, 
    }];
    
  };

  getOtcCashoutFormTotal = (controls, accounts, isFxRateFixed) => {
    return new Form(
      {
        provider: "All",
        account: "All",
        currency: controls.fxPair.split("/")[1],
        availableBalance: accounts.reduce((acc, item) => acc + parseFloat(item.balance), 0).toFixed(2),
        disputedFunds: accounts.reduce((acc, item) => acc + parseFloat(item.disputedFunds), 0).toFixed(2),
        payments: accounts.reduce((acc, item) => acc + parseFloat(item.payments), 0).toFixed(2),
        topUps: accounts.reduce((acc, item) => acc + parseFloat(item.topUps), 0).toFixed(2),
        collected: accounts.reduce((acc, item) => acc + parseFloat(item.collected), 0).toFixed(2),
        requestedBalance: "",
        fxRate: isFxRateFixed ? 1 : "",
        fxPair: this.getFxPairValue(controls.fxPair),
        incomingFunds: ""
      },
      [
        {
          name: "account",
          type: "isString",
          rules: {
            required: true
          },
        },
        {
          name: "currency",
          type: "isString",
        },
        {
          name: "totalAvailableBalance",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "requestedBalance",
          type: "isString",
          rules: {
            required: accounts.reduce((acc, item) => acc + parseFloat(item.balance).toFixed(2), 0) > 0,
          },
        },
        {
          name: "fxRate",
          type: "isString",
        },
        {
          name: "fxPair",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "incomingFunds",
          type: "isString",
          rules: {
            required: accounts.reduce((acc, item) => acc + parseFloat(item.balance).toFixed(2), 0) > 0,
          },
        }
      ]
    );
  };

  getAccountRowOtcCashoutForm = (account, controls, companiesAccounts, companiesPsps, isFxRateFixed) => {
    const accountInfo = companiesAccounts[controls.company].find(item => item.value === Number(account.pspAccountId));
    return new Form(
      {
        provider: companiesPsps[controls.company].find(item => Number(item.value) === accountInfo.pspId).label,
        account: accountInfo.label,
        accountId: account.pspAccountId,
        currency: controls.fxPair.split("/")[1],
        disputedFunds: parseFloat(account.disputedFunds).toFixed(2),
        payments: parseFloat(account.payments).toFixed(2),
        topUps: parseFloat(account.topUps).toFixed(2),
        collected: parseFloat(account.collected).toFixed(2),
        availableBalance: parseFloat(account.balance).toFixed(2),
        requestedBalance: "",
        fxRate: isFxRateFixed ? 1 : "",
        fxPair: this.getFxPairValue(controls.fxPair),
        incomingFunds: "",
        disabled: account.balance <= 0,
        isChecked: false
      },
      [
        {
          name: "account",
          type: "isString",
          rules: {
            required: true
          },
        },
        {
          name: "currency",
          type: "isString",
        },
        {
          name: "availableBalance",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "requestedBalance",
          type: "isString",
          rules: {
          },
        },
        {
          name: "fxRate",
          type: "isString",
          rules: {
          },
        },
        {
          name: "fxPair",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "incomingFunds",
          type: "isString",
          rules: {
          },
        }
      ]
    );
  };

  getFxPairValue = (fxPair) => {
    return fxPair.split("/")[0] === fxPair.split("/")[1] ? fxPair.split("/")[1] : fxPair;
  };
  
  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };
  
  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = (message) => {
    this.props.updateStateAfterSuccessSave(message);
  };

  errorUpdate = (message, typeAlert) => {
    this.props.showErrorAlert(message, typeAlert);
  };

  render() {
    return <></>;
  };
}

export default OtcCashoutComponent;